import { render, staticRenderFns } from "./GestionOnduleurs.vue?vue&type=template&id=bb4b64e4&"
import script from "./GestionOnduleurs.vue?vue&type=script&lang=js&"
export * from "./GestionOnduleurs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports